var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.33,
    height: 21.33,
    viewBox: "0 0 21.33 21.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1803.67 -931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.33,21.33H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H19.33a2,2,0,0,1,2,2V19.33A2,2,0,0,1,19.33,21.33Zm-9.192-15.5a5.3,5.3,0,1,0,5,7.061.53.53,0,1,0-1-.349,4.238,4.238,0,1,1-3.994-5.653h.005a4.155,4.155,0,0,1,3.179,1.473l-.879.779a.53.53,0,0,0,.349.927h2.384a.531.531,0,0,0,.53-.53V7.422a.531.531,0,0,0-.88-.4l-.72.642a5.186,5.186,0,0,0-3.963-1.833Z",
    transform: "translate(1803.67 931)",
    fill: "#1f2e3d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshMapIcon);
export default __webpack_public_path__ + "static/media/refresh-map-icon.e109d3261db9013337eb09c8e3dcc744.svg";
export { ForwardRef as ReactComponent };